import "../AppMobile.css";
import { Button, Grid, Typography } from "@mui/material";
import ButtonCeci from "./ButtonCeci";

export default function Card4() {
    return (
        <>
        <Grid container size={12} sx={{width: '90%', marginLeft: '10%', marginTop: '15vh'}}>
            <Grid item size={7} sx={{textAlign: 'left'}}>
                <div className="stile-titolo bianco">Quando rivolgersi a me</div>
                <div style={{marginTop: '6vw'}}className="stile-sottotitolo bianco">Per imparare a muovere il corpo in modo autonomo e consapevole, riscoprendo i benefici del movimento attraverso un percorso olistico e personalizzato, <br/>costruito sulle tue esigenze e i tuoi obiettivi.</div>                
            </Grid>
        </Grid>
        <img src="/assets/tablet/Card_4.svg" style={{ width: '100%', marginBottom: '10vh' }}/>        
        </>
    );
}
